import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';

import { alertSlice } from './alertSlice';
import { assignmentApi } from './assignmentApi';
import { assignmentSlice } from './assignmentSlice';
import { pageSlice } from './pageSlice';
import { performanceApi } from './performanceApi';
import { toastSlice } from './toastSlice';
import { tournamentApi } from './tournamentApi';
import { tournamentSlice } from './tournamentSlice';
import { userApi } from './userApi';
import { groupApi } from './groupApi';

export const store = configureStore({
    reducer: {
        [userApi.reducerPath]: userApi.reducer,
        [assignmentApi.reducerPath]: assignmentApi.reducer,
        [tournamentApi.reducerPath]: tournamentApi.reducer,
        [pageSlice.name]: pageSlice.reducer,
        [toastSlice.name]: toastSlice.reducer,
        [tournamentSlice.name]: tournamentSlice.reducer,
        [assignmentSlice.name]: assignmentSlice.reducer,
        [alertSlice.name]: alertSlice.reducer,
        [performanceApi.reducerPath]: performanceApi.reducer,
        [groupApi.reducerPath]: groupApi.reducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware().concat(
            tournamentApi.middleware,
            userApi.middleware,
            assignmentApi.middleware,
            performanceApi.middleware,
            groupApi.middleware,
        ),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

setupListeners(store.dispatch);
